export * from "@vaadin/message-input/vaadin-message-input.js";
export * from './generated/MessageInput.js';
